/* ++++++++++ --------------- DIMENSIONS AND METRICS : STYLES --------------- ++++++++++ */
import {pxToEm} from "@insticator/insticator-ui";

export default theme => ({
    checkListSection:{
        display: 'flex',
        flexDirection: 'row',
        gap: pxToEm(24),
        padding: pxToEm(20),
    },
})